import { cva } from "class-variance-authority";

export const buttonVariants = cva(
  "inline-flex items-center justify-center whitespace-nowrap rounded-lg text-sm font-medium transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        primary:
          "bg-gradient-to-r from-gray-800 via-primary to-gray-800 bg-[size:200%_auto] text-white hover:bg-[right_center] !px-6 !py-3 lg:!py-4 disabled:opacity-100",
        default:
          "bg-primaryLight text-gray-900 hover:bg-primary hover:text-white",
        ghost: "text-gray-500 hover:text-gray-700",
        filled: "bg-primary text-white hover:bg-primary/95",
        // An ARMED canvas tool (slicer, paint, draw). Its own rung above resting and hover, with the icon going bright — a value step rather than the accent purple, which made a mode toggle read as a branded action, and short of a full inversion to gray-200, which is unmistakable but far too loud for a mode toggle in chrome this quiet. Same rounded rectangle as its resting twin — an armed control is the same object lit, not a differently shaped one.
        ttvArmed:
          "rounded-none bg-ttvArmed text-white hover:brightness-125 gap-2.5 transition-all",
        error: "bg-red-600 text-white hover:bg-red-500",
        errorOutline:
          "border border-red-300 bg-white text-red-600 hover:bg-red-50",
        outline:
          "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
        // No resting fill: the fill belongs to the GROUP now, not to each control. Twenty-one controls each wearing their own is twenty-one objects competing, which reads as cluttered; filling the group and leaving the controls bare until touched lets that many controls sit quietly. Hover and armed still fill, so the eye lands on what is actually on.
        ttv: "rounded-none text-ttvText hover:bg-ttvHover gap-2.5 transition-colors",
        // Secondary action inside a dark (theme="dark") modal: the ghost variant's gray-on-gray disappears there. Same chip shade as ttv (APP-376's neutral palette), rounded like a normal button.
        darkSecondary: "bg-ttvRaised text-gray-100 hover:bg-ttvArmed",
        // The Text to vocals welcome page's call to action: a pale pill on the dark ground, also worn by the screens shown in place of the editor so the two read as one product.
        ttvPill:
          "bg-primaryLight text-gray-900 hover:bg-white focus-visible:ring-primary focus-visible:ring-offset-ttvWell",
      },
      size: {
        default: "px-4 py-2",
        xs: "h-8 px-1 text-xs font-normal",
        sm: "h-9 rounded-md px-3",
        lg: "h-11 rounded-md px-8",
        icon: "h-10 w-10",
      },
    },
    compoundVariants: [
      { variant: ["ttv", "ttvArmed"], size: "xs", class: "px-2" },
      // A compound rather than part of the variant, so the pill's shape wins over whichever size is passed.
      { variant: "ttvPill", class: "rounded-full px-6 py-3 text-base" },
    ],
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);
